import { render, staticRenderFns } from "./reviewDev.vue?vue&type=template&id=26fa8749&"
import script from "./reviewDev.vue?vue&type=script&lang=js&"
export * from "./reviewDev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports